import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class CompanyApi extends EntityApi {
    protected static GET_COLLECTION = "/api/companies";

    protected static POST_COLLECTION = "/api/companies";

    protected static GET_ITEM = "/api/companies/{id}";

    protected static PUT_ITEM = "/api/companies/{id}";

    protected static PATCH_ITEM = "/api/companies/{id}";

    protected static DELETE_ITEM = "/api/companies/{id}";

    protected static GET_COLLECTION_MY_COMPANIES = "/api/companies/my";

    protected static GET_COLLECTION_FIND = "/api/companies/find";

    protected static GET_COLLECTION_FIND_FOR_MAP =
        "/api/companies/find-for-map";

    protected static GET_COLLECTION_MY_PARTNERSHIP =
        "/api/companies/my-partnership";

    public static async getCollectionMyCompanies<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_MY_COMPANIES,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getCollectionFindCompanies<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FIND,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getCollectionFindCompaniesForMap<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FIND_FOR_MAP,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getCollectionMyPartnership<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_MY_PARTNERSHIP,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
